import React, { type ComponentPropsWithoutRef } from "react";
const baseInput = "w-full rounded-input border bg-surface px-3 py-2 text-sm text-fg placeholder:text-fg-subtle focus:outline-none focus:ring-2 disabled:opacity-60 disabled:cursor-not-allowed transition-colors";
const okBorder = "border-border-strong focus:border-brand-500 focus:ring-brand-500/20";
const errBorder = "border-danger focus:border-danger focus:ring-danger/20";
export type InputProps = ComponentPropsWithoutRef<"input"> & {
    invalid?: boolean;
};
export const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input({ className = "", invalid = false, ...props }: Record<string, any>, ref: any): any {
    return (<input ref={ref} className={`${baseInput} ${invalid ? errBorder : okBorder} ${className}`} {...props}/>);
});
export type TextareaProps = ComponentPropsWithoutRef<"textarea"> & {
    invalid?: boolean;
};
export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea({ className = "", invalid = false, rows = 3, ...props }: Record<string, any>, ref: any): any {
    return (<textarea ref={ref} rows={rows} className={`${baseInput} ${invalid ? errBorder : okBorder} ${className}`} {...props}/>);
});
export type SelectProps = ComponentPropsWithoutRef<"select"> & {
    invalid?: boolean;
};
export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(function Select({ className = "", invalid = false, children, ...props }: Record<string, any>, ref: any): any {
    return (<select ref={ref} className={`${baseInput} ${invalid ? errBorder : okBorder} pr-9 cursor-pointer ${className}`} {...props}>
      {children}
    </select>);
});
Input.displayName = "Input";
Textarea.displayName = "Textarea";
Select.displayName = "Select";
